'use client';

import { useRouter } from 'next/navigation';

import { useAppDispatch } from '@/store/client/config';
import { modalActions } from '@/store/client/slices/modalSlice';

import { useEventPhase } from './useEventPhase';

// 참여 액션 버튼 공통 핸들러. 대회 종료(9/6~)면 종료 모달, 아니면 해당 페이지로 이동.
export function useSeoleimrunNavigate() {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { isEnded } = useEventPhase();

  // guardOnEnded: 종료 후 모달로 막을지. 참여 액션(선물/영수증/MY)은 true, 문의/안내는 false.
  return (href: string, { guardOnEnded = true }: { guardOnEnded?: boolean } = {}) => {
    if (guardOnEnded && isEnded) {
      dispatch(
        modalActions.openAlertModal({
          icon: 'none',
          title: ['이벤트가 종료되었어요'],
          description: ['2027년 설레임런을 기대해주세요'],
          closeText: ['확인'],
        }),
      );
      return;
    }

    router.push(href);
  };
}
